var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "main-internal-section width-full float-l" }, [
        _c(
          "div",
          { staticClass: "container" },
          [
            _vm.cantAccessPage === true
              ? [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "chat-btm-section-main add-user-main-section width-full float-l"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "web-add-form float-l width-full" },
                          [
                            _c(
                              "h2",
                              {
                                staticClass:
                                  "chat-page-title float-l colpie-80 color-333333 heading-text-18 line-height-22 font-bold ucase"
                              },
                              [_vm._v(" " + _vm._s(_vm.headerText) + " ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "add-user-form width-full float-l mt_10"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "top-label-section float-l width-full"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group float-l width-full p_15"
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"
                                          },
                                          [_vm._v(" Dayforce ID ")]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.emp_id,
                                              expression: "emp_id"
                                            }
                                          ],
                                          staticClass:
                                            "form-control custom-select",
                                          attrs: {
                                            type: "text",
                                            disabled: _vm.isUpdate,
                                            name: "Employee Id",
                                            id: "emp_id",
                                            placeholder: "Type Dayforce ID"
                                          },
                                          domProps: { value: _vm.emp_id },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.emp_id = $event.target.value
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "help is-danger" },
                                          [_vm._v(_vm._s(_vm.emp_error_msg))]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    !_vm.isUpdate
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "register-btn dayforce-id-btn float-l col-12"
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-primary internal-large-btn float-l mr_20",
                                                attrs: { type: "submit" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.getUserDetails()
                                                  }
                                                }
                                              },
                                              [
                                                _c("span", {
                                                  staticClass: "gradient"
                                                }),
                                                _vm._v(
                                                  "Get User Detail\n                                        "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group float-l width-full p_15"
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"
                                          },
                                          [_vm._v(" Name ")]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            },
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.name,
                                              expression: "name"
                                            }
                                          ],
                                          staticClass:
                                            "form-control custom-select",
                                          attrs: {
                                            type: "text",
                                            disabled: _vm.isUpdate,
                                            name: "Name",
                                            id: "name",
                                            placeholder: "Type your name"
                                          },
                                          domProps: { value: _vm.name },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.name = $event.target.value
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.errors.has("Name"),
                                                expression: "errors.has('Name')"
                                              }
                                            ],
                                            staticClass: "help is-danger"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.errors.first("Name"))
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group float-l width-full p_15"
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"
                                          },
                                          [_vm._v(" Email address ")]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required|email",
                                              expression: "'required|email'"
                                            },
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.email,
                                              expression: "email"
                                            }
                                          ],
                                          staticClass:
                                            "form-control custom-select",
                                          attrs: {
                                            type: "text",
                                            disabled: _vm.isUpdate,
                                            name: "E-mail",
                                            id: "email",
                                            placeholder: "Type your email"
                                          },
                                          domProps: { value: _vm.email },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.email = $event.target.value
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.errors.has("E-mail"),
                                                expression:
                                                  "errors.has('E-mail')"
                                              }
                                            ],
                                            staticClass: "help is-danger"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.errors.first("E-mail"))
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    !_vm.isUpdate
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "form-group float-l width-full p_15"
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"
                                              },
                                              [_vm._v(" Password ")]
                                            ),
                                            _vm._v(" "),
                                            _vm.pType === "checkbox"
                                              ? _c("input", {
                                                  directives: [
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: "required|min:6",
                                                      expression:
                                                        "'required|min:6'"
                                                    },
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.password,
                                                      expression: "password"
                                                    }
                                                  ],
                                                  ref: "Password",
                                                  staticClass:
                                                    "form-control custom-select",
                                                  attrs: {
                                                    name: "Password",
                                                    id: "pwd",
                                                    placeholder:
                                                      "Type your passowrd",
                                                    type: "checkbox"
                                                  },
                                                  domProps: {
                                                    checked: Array.isArray(
                                                      _vm.password
                                                    )
                                                      ? _vm._i(
                                                          _vm.password,
                                                          null
                                                        ) > -1
                                                      : _vm.password
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      var $$a = _vm.password,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = null,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            (_vm.password = $$a.concat(
                                                              [$$v]
                                                            ))
                                                        } else {
                                                          $$i > -1 &&
                                                            (_vm.password = $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              ))
                                                        }
                                                      } else {
                                                        _vm.password = $$c
                                                      }
                                                    }
                                                  }
                                                })
                                              : _vm.pType === "radio"
                                              ? _c("input", {
                                                  directives: [
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: "required|min:6",
                                                      expression:
                                                        "'required|min:6'"
                                                    },
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.password,
                                                      expression: "password"
                                                    }
                                                  ],
                                                  ref: "Password",
                                                  staticClass:
                                                    "form-control custom-select",
                                                  attrs: {
                                                    name: "Password",
                                                    id: "pwd",
                                                    placeholder:
                                                      "Type your passowrd",
                                                    type: "radio"
                                                  },
                                                  domProps: {
                                                    checked: _vm._q(
                                                      _vm.password,
                                                      null
                                                    )
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      _vm.password = null
                                                    }
                                                  }
                                                })
                                              : _c("input", {
                                                  directives: [
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: "required|min:6",
                                                      expression:
                                                        "'required|min:6'"
                                                    },
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.password,
                                                      expression: "password"
                                                    }
                                                  ],
                                                  ref: "Password",
                                                  staticClass:
                                                    "form-control custom-select",
                                                  attrs: {
                                                    name: "Password",
                                                    id: "pwd",
                                                    placeholder:
                                                      "Type your passowrd",
                                                    type: _vm.pType
                                                  },
                                                  domProps: {
                                                    value: _vm.password
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.password =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.errors.has(
                                                      "Password"
                                                    ),
                                                    expression:
                                                      "errors.has('Password')"
                                                  }
                                                ],
                                                staticClass: "help is-danger"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.errors.first("Password")
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: "javascript:void(0)"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.hideShow(this)
                                                  }
                                                }
                                              },
                                              [_vm._m(0)]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.isUpdate
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "form-group float-l width-full p_15"
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"
                                              },
                                              [_vm._v(" Confirm Password ")]
                                            ),
                                            _vm._v(" "),
                                            _vm.cType === "checkbox"
                                              ? _c("input", {
                                                  directives: [
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value:
                                                        "required|confirmed:Password",
                                                      expression:
                                                        "'required|confirmed:Password'"
                                                    },
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.cpassword,
                                                      expression: "cpassword"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "form-control custom-select",
                                                  attrs: {
                                                    name: "Confirm Password",
                                                    id: "cpwd",
                                                    placeholder:
                                                      "Confirm your passowrd",
                                                    type: "checkbox"
                                                  },
                                                  domProps: {
                                                    checked: Array.isArray(
                                                      _vm.cpassword
                                                    )
                                                      ? _vm._i(
                                                          _vm.cpassword,
                                                          null
                                                        ) > -1
                                                      : _vm.cpassword
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      var $$a = _vm.cpassword,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = null,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            (_vm.cpassword = $$a.concat(
                                                              [$$v]
                                                            ))
                                                        } else {
                                                          $$i > -1 &&
                                                            (_vm.cpassword = $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              ))
                                                        }
                                                      } else {
                                                        _vm.cpassword = $$c
                                                      }
                                                    }
                                                  }
                                                })
                                              : _vm.cType === "radio"
                                              ? _c("input", {
                                                  directives: [
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value:
                                                        "required|confirmed:Password",
                                                      expression:
                                                        "'required|confirmed:Password'"
                                                    },
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.cpassword,
                                                      expression: "cpassword"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "form-control custom-select",
                                                  attrs: {
                                                    name: "Confirm Password",
                                                    id: "cpwd",
                                                    placeholder:
                                                      "Confirm your passowrd",
                                                    type: "radio"
                                                  },
                                                  domProps: {
                                                    checked: _vm._q(
                                                      _vm.cpassword,
                                                      null
                                                    )
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      _vm.cpassword = null
                                                    }
                                                  }
                                                })
                                              : _c("input", {
                                                  directives: [
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value:
                                                        "required|confirmed:Password",
                                                      expression:
                                                        "'required|confirmed:Password'"
                                                    },
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.cpassword,
                                                      expression: "cpassword"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "form-control custom-select",
                                                  attrs: {
                                                    name: "Confirm Password",
                                                    id: "cpwd",
                                                    placeholder:
                                                      "Confirm your passowrd",
                                                    type: _vm.cType
                                                  },
                                                  domProps: {
                                                    value: _vm.cpassword
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.cpassword =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.errors.has(
                                                      "Confirm Password"
                                                    ),
                                                    expression:
                                                      "errors.has('Confirm Password')"
                                                  }
                                                ],
                                                staticClass: "help is-danger"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.errors.first(
                                                      "Confirm Password"
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: "javascript:void(0)"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.hideShowCPass(
                                                      this
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._m(1)]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "btm-label-section float-l width-full bgcolor-f5f5f5"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group float-l width-full p_15"
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"
                                          },
                                          [_vm._v(" Timezone ")]
                                        ),
                                        _vm._v(" "),
                                        _c("v-select", {
                                          attrs: {
                                            clearable: false,
                                            name: "timezoneId",
                                            placeholder: "Select Timezone.",
                                            label: "text",
                                            options: _vm.timezoneArr
                                          },
                                          model: {
                                            value: _vm.timezoneId,
                                            callback: function($$v) {
                                              _vm.timezoneId = $$v
                                            },
                                            expression: "timezoneId"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "add-user-role-add-title float-l width-full"
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "color-333333 heading-text-16 line-height-18 font-benton-bold ucase mt_20 float-l colpie-70"
                                          },
                                          [_vm._v(" Section / Role ")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-primary internal-large-btn internal-large-btn-blue float-l colpie-30 mt_15 float-r",
                                            attrs: { type: "submit" },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.addLine(this)
                                              }
                                            }
                                          },
                                          [
                                            _c("span", {
                                              staticClass: "gradient"
                                            }),
                                            _vm._v(
                                              "  Add\n                                        "
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "role-internal-section float-l width-full"
                                      },
                                      [
                                        _vm._l(_vm.generateSectionArr, function(
                                          section,
                                          index
                                        ) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                key: index,
                                                staticClass:
                                                  "role-add-section float-l width-full"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "section-role-title-section float-l width-full"
                                                  },
                                                  [
                                                    _c("h3", [
                                                      _vm._v(
                                                        " Add " +
                                                          _vm._s(index + 1) +
                                                          " "
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    [
                                                      _c("a", {
                                                        staticClass:
                                                          "fa fa-times fa-2 close-section",
                                                        attrs: { href: "" },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.removeLine(
                                                              index,
                                                              section.sectionId,
                                                              section.roleId
                                                            )
                                                          }
                                                        }
                                                      })
                                                    ]
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                void 0,
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "form-group float-l width-full p_15"
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"
                                                      },
                                                      [_vm._v(" Section ")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("v-select", {
                                                      attrs: {
                                                        clearable: false,
                                                        name: "sectionId",
                                                        placeholder:
                                                          "Select Section.",
                                                        label: "text",
                                                        options: _vm.sectionArr
                                                      },
                                                      model: {
                                                        value:
                                                          section.sectionId,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            section,
                                                            "sectionId",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "section.sectionId"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "help is-danger"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            section.section_error_msg
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "form-group float-l width-full p_15"
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"
                                                      },
                                                      [_vm._v(" Role ")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("v-select", {
                                                      attrs: {
                                                        clearable: false,
                                                        name: "roleId",
                                                        placeholder:
                                                          "Select Role.",
                                                        label: "text",
                                                        options: _vm.roleArr
                                                      },
                                                      model: {
                                                        value: section.roleId,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            section,
                                                            "roleId",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "section.roleId"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "help is-danger"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            section.role_error_msg
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              2
                                            )
                                          ]
                                        })
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "register-btn float-l col-12"
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-primary internal-large-btn float-l mr_20",
                                            attrs: { id: "", type: "submit" },
                                            on: {
                                              click: function($event) {
                                                return _vm.createUser()
                                              }
                                            }
                                          },
                                          [
                                            _c("span", {
                                              staticClass: "gradient"
                                            }),
                                            _vm._v(
                                              "   " +
                                                _vm._s(_vm.btnText) +
                                                "\n                                        "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-primary internal-large-btn internal-small-btn float-l",
                                            attrs: { type: "submit" },
                                            on: {
                                              click: function($event) {
                                                return _vm.backToUser()
                                              }
                                            }
                                          },
                                          [
                                            _c("span", {
                                              staticClass: "gradient"
                                            }),
                                            _vm._v(
                                              "  Back\n                                        "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "modal fade forward-chat-modal email-chat-modal",
                      attrs: {
                        id: "password",
                        tabindex: "-1",
                        role: "dialog",
                        "aria-labelledby": "password",
                        "aria-hidden": "true"
                      }
                    },
                    [
                      _c("div", { staticClass: "modal-dialog" }, [
                        _c("div", { staticClass: "modal-content" }, [
                          _vm._m(2),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "modal-body email-chat-main float-l width-full p_0"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "form-group float-l width-full p_15"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.changePassword,
                                        expression: "changePassword"
                                      }
                                    ],
                                    staticClass: "form-control custom-select",
                                    attrs: {
                                      type: "password",
                                      name: "email",
                                      placeholder: "Enter your Password",
                                      onfocus: "this.placeholder = ''",
                                      onblur:
                                        "this.placeholder = 'Enter your Password'"
                                    },
                                    domProps: { value: _vm.changePassword },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.changePassword = $event.target.value
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "help is-danger" }, [
                                    _vm._v(_vm._s(_vm.chagne_pwd_error_msg))
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "form-group float-l width-full p_15"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.changeCPassword,
                                        expression: "changeCPassword"
                                      }
                                    ],
                                    staticClass: "form-control custom-select",
                                    attrs: {
                                      type: "password",
                                      name: "email",
                                      placeholder: "Confirm your Password",
                                      onfocus: "this.placeholder = ''",
                                      onblur:
                                        "this.placeholder = 'Confirm your Password'"
                                    },
                                    domProps: { value: _vm.changeCPassword },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.changeCPassword =
                                          $event.target.value
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "help is-danger" }, [
                                    _vm._v(_vm._s(_vm.chagne_cpwd_error_msg))
                                  ])
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "chat-forward-btm float-l width-full relative pl_15 pr_15"
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-primary internal-large-btn float-l mr_20",
                                  attrs: { type: "update" },
                                  on: {
                                    click: function($event) {
                                      return _vm.chagnePasswrodAPI()
                                    }
                                  }
                                },
                                [
                                  _c("span", { staticClass: "gradient" }),
                                  _vm._v(
                                    " Send\n                                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-primary internal-large-btn internal-small-btn float-l",
                                  attrs: { type: "submit" },
                                  on: {
                                    click: function($event) {
                                      return _vm.changePasswordModalClose()
                                    }
                                  }
                                },
                                [
                                  _c("span", { staticClass: "gradient" }),
                                  _vm._v(
                                    "  Cancel\n                                "
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      ])
                    ]
                  )
                ]
              : [_vm.isRequestComplete ? [_vm._m(3)] : _vm._e()]
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("app-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "fa fa-eye" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "fa fa-eye" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      ),
      _vm._v(" "),
      _c("h4", { staticClass: "modal-title", attrs: { id: "myModalLabel" } }, [
        _vm._v("Change Password")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("div", { staticClass: "error-template" }, [
        _c("h1", [_vm._v("\n                                Oops!")]),
        _vm._v(" "),
        _c("h2", [_vm._v("\n                                403 ")]),
        _vm._v(" "),
        _c("div", { staticClass: "error-details" }, [
          _vm._v(
            "\n                                Sorry!, You don't have permission to access this page.\n                            "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-99d6ff44", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99d6ff44","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users/UserCreate.vue
// module id = null
// module chunks = 